import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as nganhHangAction from './actions'
import * as nganhHangConstant from './constants'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class NganhHangEdit extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    nganhHangUpdateRequest: PropTypes.func,
    nganhHangDetailRequest: PropTypes.func,
    nganhHangListRequest: PropTypes.func,
    nganhHangEdit: PropTypes.shape({
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        Ten: "",
        IsDeleted: -1,
        StoresId: dbContext.getStoreId(),
      },
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    switch (name) {
      case "TrangThai":
        item.IsDeleted = selectedOption.target.value
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { nganhHangDetailRequest } = this.props
    let nganhHangId = this.getParam("nganhhang");
    var requestData = {
      nganhHangId: nganhHangId || 0
    }
    return nganhHangDetailRequest(requestData);
  }
  UpdateNganhHang = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Ten || this.state.item.Ten == "") {
      formError.Ten = 'Bạn chưa nhập tên nhóm sản phẩm';
    }
    if (this.state.item.IsDeleted == -1) {
      formError.Status = 'Bạn chưa nhập trạng thái';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state
      this.props.nganhHangUpdateRequest(item);
    }
  }
  BackToListNganhHang = (item, e) => {
    this.props.history.push('/nganhhang');
  }
  componentDidMount() {
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.nganhHangEdit.type == nganhHangConstant.NGANHHANG_DETAIL_SUCCESS) {
      let { item } = nextProps.nganhHangEdit;
      if (item.NganhHangId && item.NganhHangId > 0) {
        this.setState({
          item: item
        });
      }
    } else if (nextProps.nganhHangEdit.type == nganhHangConstant.NGANHHANG_UPDATE_SUCCESS) {
      this.props.history.push("/nganhhang");
    }
  }
  render() {
    const { formError, item } = this.state;
    const {
      handleSubmit,
      nganhHangEdit: {
        listnganhHang,
        isRequesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <Form>
            <FormGroup>
              <Label for="nganhHang">Tên nhóm sản phẩm</Label>
              <Input type="text" name="Ten" id="nganhHang" placeholder="Tên nhóm" value={item.Ten || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ten}</em>
            </FormGroup>
            <FormGroup>
              <Label for="statusSelect">Trạng thái</Label>
              <select name="IsDeleted" id="statusSelect" className="form-control" value={item.IsDeleted} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                <option value={-1}>--Trạng thái--</option>
                <option value={0}>Hoạt động</option>
                <option value={1}>Ngừng hoạt động</option>
              </select>
              <em className="error invalid-feedback">{formError.Status}</em>
            </FormGroup>
          </Form>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListNganhHang()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdateNganhHang()}
              permission={BtnPermissions.NganhHang.ADD_OR_UPDATE} />
            {/* <ButtonExt btnClass="mr-1"
              color="secondary"
              iconClass="fa-close"
              displayText="Hủy"
              btnClick={() => this.Cancel()}
              permission={""} /> */}
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  nganhHangEdit: state.nganhHangEdit,
})
const connected = connect(mapStateToProps, {
  nganhHangDetailRequest: nganhHangAction.nganhHangDetailRequest,
  nganhHangUpdateRequest: nganhHangAction.nganhHangUpdateRequest,
  nganhHangListRequest: nganhHangAction.nganhHangListRequest,
})(NganhHangEdit)

const formed = reduxForm({
  form: 'nganhHangEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/NganhHang/NganhHangEdit.js